<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.addBtn"
          @click="openhouseholdAddDialog"
        >
          新增
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="small"
          plain
          v-if="permissionList.delBtn"
          @click="handleDelete"
        >
          删 除
        </el-button>
      </template>

      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permissionList.editBtn"
          @click.native="openhouseholdEditDialog(scope.row)"
          >编辑
        </el-button>
        <el-button
          type="text"
          icon="el-icon-delete"
          size="small"
          v-if="permissionList.delBtn"
          @click.native="rowDel(scope.row)"
          >删除
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="新增"
      :visible.sync="householdAddShowDialogFlag"
      :modal-append-to-body="false"
      @opened="householdAddDialogOpened"
    >
      <div class="el-household-dialog-div">
        <avue-form
          ref="householdAddFormRef"
          v-model="householdAddForm"
          :option="householdAddOption"
          @reset-change="householdAddReset"
          @submit="householdAddSubmit"
        >
          <template slot-scope="scope" slot="parentId">
            <el-select
              :value="parentObjectName"
              ref="householdAddParentNodeSelectRef"
              placeholder="请选择房产信息"
              clearable
              @clear="householdAddClearParentNodeSelect"
              @click.native="householdAddClickParentNodeSelect"
            >
              <el-option :value="parentObjectName" :label="parentObjectName">
                <el-tree
                  ref="householdAddParentNodeTreeRef"
                  node-key="id"
                  :props="treeProps"
                  :load="lazyLoadhouseholdAddParentNodeTree"
                  lazy
                  @node-click="householdAddParentNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quithouseholdAddDialog">退出</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="householdEditShowDialogFlag"
      :modal-append-to-body="false"
      @opened="householdEditDialogOpened"
    >
      <div class="el-household-dialog-div">
        <avue-form
          ref="householdEditFormRef"
          v-model="householdEditForm"
          :option="householdEditOption"
          @reset-change="householdEditReset"
          @submit="householdEditSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quithouseholdEditDialog">退出</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  getDetailById,
  getRoomInfo,
  getTrackTree,
  getTreeChildrenNode,
  addProperty,
  updateProperty,
  getTreeChildrenPowerNode,
  treeChildrenPowerNodeCount,
  lazyBasePropertyTree,
} from '@/api/v4ward/property/baseproperty';
import { add, getDetail, getList, remove, update } from '@/api/v4ward/household/basehousehold';
import { mapGetters } from 'vuex';
import treeOption from './tree-option';
import householdAddOption from './household-add-option';
/*import householdOption from './household-option';*/
import householdEditOption from './household-edit-option';

export default {
  data() {
    return {
      reWrite: false,
      addBtnShow: false,
      delBtnShow: false,
      firstDisplayFlag: false,
      tempPropertyParentId: '',
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        // objectTypeName: 'objectTypeName',
        objectTypeName: 'roomName',
      },
      ishouseholdAddDialogFirstOpen: true,
      householdAddParentNodeTreeRoot: {},
      householdAddParentNodeTreeResolve: {},
      commitList: {},

      //选中的树形节点信息
      treeTrackId: '',
      filterText: '',

      //选中的表格行信息
      tableTrackId: '',

      //父节点树结构相关信息
      parentId: '',
      parentObjectName: '',
      parentObjectTypeName: '',

      //窗口显示开关
      householdAddShowDialogFlag: false,
      householdEditShowDialogFlag: false,

      //form表单数据
      form: {},
      householdAddForm: {},
      householdEditForm: {},

      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 4,
        calcHeight: 30,
        tip: false,
        border: true,
        index: false,
        selection: true,
        viewBtn: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        columnBtn: false,
        column: [
          {
            lazy: true,
            label: '房产名称',
            prop: 'propertyParentId',
            type: 'tree',
            searchSpan: 6,
            search: true,
            hide: true,
            display: false,
            props: {
              labelText: '标题',
              label: 'objectFullName',
              value: 'value',
              children: 'children',
            },
            treeLoad: function (node, resolve) {
              const id = node.level === 0 ? 0 : node.data.id;
              lazyBasePropertyTree(id).then((res) => {
                resolve(
                  res.data.map((item) => {
                    return {
                      ...item,
                      leaf: !item.hasChildren,
                    };
                  })
                );
              });
            },
          },
          {
            label: '房产名称',
            prop: 'roomName',
            width: 200,
            rules: [
              {
                required: true,
                trigger: 'change',
              },
            ],
          },
          // {
          //   label: '人员编码',
          //   prop: 'householdCode',
          //   hide:true,
          //
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入人员编码',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            label: '人员名称',
            prop: 'householdName',
            searchSpan: 5,
            search: true,
            width: 200,
            rules: [
              {
                required: true,
                message: '请输入人员名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '人员类型',
            prop: 'householdType',
            width: 80,
            type: 'select',
            editDisabled: true,
            search: true,
            searchSpan: 4,
            searchPlaceholder: '请选择',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            valueType:'string',
            dicUrl: '/api/blade-system/dict/dictionary?code=household_type',
            rules: [
              {
                required: true,
                trigger: 'change',
              },
            ],
          },

          {
            label: '性别',
            prop: 'sex',
            width: 50,
            type: 'select',
            editDisabled: true,

            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            rules: [
              {
                required: true,
                trigger: 'change',
              },
            ],
          },
          {
            label: '联系电话',
            prop: 'linkPhone',
            searchSpan: 5,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入联系方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '身份证',
            prop: 'idCard',
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入身份证',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            label: '邮箱',
            prop: 'email',
          },
          {
            label: 'QQ',
            prop: 'qq',
          },
          // {
          //   label: '公司',
          //   prop: 'companyName',
          //
          // },
        ],
      },
      treeOption: treeOption,
      /*householdOption: householdOption,*/
      householdAddOption: householdAddOption,
      householdEditOption: householdEditOption,

      //页面数据
      treeData: [],
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basehousehold_add, false),
        viewBtn: this.vaildData(this.permission.basehousehold_view, false),
        delBtn: this.vaildData(this.permission.basehousehold_delete, false),
        editBtn: this.vaildData(this.permission.basehousehold_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initAddBtnShow();
    this.initDelBtnShow();
    //加载列表
    lazyBasePropertyTree(0).then((res) => {
      this.commitList = res.data;
      if (this.commitList.length > 0) {
        this.query.propertyParentId = this.commitList[0].id;
        this.tempPropertyParentId = this.commitList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.leftTreeRef.filter(val);
    },
  },
  methods: {
    initAddBtnShow() {
      treeChildrenPowerNodeCount({ power: 2 }).then(({ data }) => {
        if (data > 0) this.addBtnShow = true;
      });
    },
    initDelBtnShow() {
      treeChildrenPowerNodeCount({ power: 3 }).then(({ data }) => {
        if (data > 0) this.delBtnShow = true;
      });
    },
    //懒加载树结构
    lazyLoadhouseholdAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.householdAddParentNodeTreeRoot = node;
        this.householdAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenPowerNode({ id: id, power: 2 }).then(({ data }) => {
        resolve(data);
      });
    },
    //重新加载左侧树结构
    reloadhouseholdAddParentNodeTree() {
      this.householdAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadhouseholdAddParentNodeTree(
        this.householdAddParentNodeTreeRoot,
        this.householdAddParentNodeTreeResolve
      );
    },

    openhouseholdAddDialog() {
      this.householdAddShowDialogFlag = true;
    },
    openhouseholdEditDialog(row) {
      this.tableTrackId = row.id;
      this.householdEditShowDialogFlag = true;
    },

    //窗口打开完成回调函数
    householdAddDialogOpened() {
      this.$refs.householdAddFormRef.resetForm();

      this.parentId = '';
      this.parentObjectName = '';
      this.parentObjectTypeName = '';
      this.householdAddForm.objectTypeName = '房间';
    },
    householdEditDialogOpened() {
      this.$refs.householdEditFormRef.resetForm();

      getDetail({ id: this.tableTrackId }).then(({ data }) => {
        this.parentId = data.propertyId;
        this.parentObjectName = data.parentObjectName;
        this.parentObjectTypeName = data.parentObjectTypeName;

        this.householdEditForm.id = data.id;
        this.householdEditForm.householdCode = data.householdCode;
        this.householdEditForm.householdName = data.householdName;
        this.householdEditForm.householdTypeName = data.householdTypeName;
        this.householdEditForm.householdType =  Number(data.householdType);
        this.householdEditForm.parentId = data.propertyId;
        this.householdEditForm.sex = data.sex;
        this.householdEditForm.idCard = data.idCard;
        this.householdEditForm.email = data.email;
        this.householdEditForm.qq = data.qq;
        this.householdEditForm.companyName = data.companyName;
        this.householdEditForm.accountAmount = data.accountAmount;
        this.householdEditForm.accountRemark = data.accountRemark;
        this.householdEditForm.lockFlag = data.lockFlag;
        this.householdEditForm.pointsNumber = data.pointsNumber;
        this.householdEditForm.pointsRemark = data.pointsRemark;
        this.householdEditForm.pointsFlag = data.pointsFlag;
        this.householdEditForm.remark1 = data.remark1;
        this.householdEditForm.remark2 = data.remark2;
        this.householdEditForm.remark3 = data.remark3;
        this.householdEditForm.parentObjectTypeName = data.roomName;
        this.householdEditForm.linkPhone = data.linkPhone;
      });
    },

    // 初始化父节点树结构
    inithouseholdAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.ishouseholdAddDialogFirstOpen) {
        this.reloadhouseholdAddParentNodeTree();
      } else {
        this.ishouseholdAddDialogFirstOpen = false;
      }
    },
    initSelectTreeStyle() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0];
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },

    //点击窗口中的父节点选择框回调函数
    householdAddClickParentNodeSelect() {},
    // 窗口中父节点树节点点击回调
    householdAddParentNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];
      let nodeType = node[this.treeProps.objectType];

      this.parentObjectName = nodeTitle;
      if (nodeType !== 6) {
        this.$message.warning('请选择至房间!');
        return;
      }
      if (this.householdAddShowDialogFlag) {
        this.$refs.householdAddParentNodeSelectRef.blur();
        this.householdAddForm.parentId = nodeId;
        this.householdAddForm.parentObjectTypeName = nodeTypeName;
        this.householdAddForm.objectType = nodeType;
      }
    },

    //重置窗口数据
    householdAddReset() {
      this.inithouseholdAddParentNodeTree();
    },
    householdEditReset() {
      this.householdEditForm.id = this.tableTrackId;
      this.householdEditForm.parentId = this.parentId;
      this.householdEditForm.parentObjectName = this.parentObjectName;
      this.householdEditForm.parentObjectTypeName = this.parentObjectTypeName;
    },

    // 清除父节点树选项
    householdAddClearParentNodeSelect() {
      this.parentObjectName = '';
      this.clearTreeStyle(this.householdAddShowDialogFlag, 'householdAddParentNodeTree');
      this.$emit('getValue', null);
    },
    clearTreeStyle(showDialogFlag, treeId) {
      if (showDialogFlag) {
        let allNode = document.querySelectorAll('#' + treeId + ' .el-tree-node');
        allNode.forEach((element) => element.classList.remove('is-current'));
      }
    },

    householdAddSubmit(form, done) {
      this.$refs.householdAddFormRef.validate((valid) => {
        if (valid) {
          if (this.vdui.isEmpty(form.parentId)) {
            form.parentId = '0';
          }
          add(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.householdAddShowDialogFlag = false;
              done();
              this.$refs.householdAddFormRef.resetForm();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    householdEditSubmit(form, done) {
      this.$refs.householdEditFormRef.validate((valid) => {
        if (valid) {
          update(form).then(
            () => {
              // this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.householdEditShowDialogFlag = false;

              this.$refs.householdEditFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    quithouseholdAddDialog() {
      this.householdAddShowDialogFlag = false;
      this.$refs.householdAddFormRef.resetForm();
    },
    quithouseholdEditDialog() {
      this.householdEditShowDialogFlag = false;
      this.$refs.householdEditFormRef.resetForm();
    },

    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      let flag;
      this.selectionList.forEach(function (value, index, array) {
        if (value.dataPower == 2) {
          flag = true;
          return;
        }
      });
      if (flag) {
        this.$message.warning('请不要删除没有行删除的数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.firstDisplayFlag = true;
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (this.query.propertyParentId == undefined || this.query.propertyParentId == '') {
        this.query.propertyParentId = this.tempPropertyParentId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            var ent = document.querySelector('input[placeholder="房产名称"]');
            ent.value = this.commitList[0].title;
            this.query.propertyParentId = this.commitList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}

.el-select-dropdown__item.selected {
  font-weight: normal;
}

ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}

.el-tree-node__label {
  font-weight: normal;
}

.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}

.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-household-dialog-div {
  height: 500px;
  overflow: auto;
}
</style>
